module.exports = __webpack_public_path__ + "img/jibaboom_astronomia_bg.34da3a95.png";